import React, { Suspense } from 'react';
import { shape, string } from 'prop-types';
import { useIntl } from 'react-intl';
import { useCartTrigger } from '@magento/peregrine/lib/talons/Header/useCartTrigger';
import Cart from '@magento/venia-ui/venia-static/icons/cart.svg';
import { mergeClasses } from '../../classify';
import defaultClasses from './cartTrigger.css';
import { GET_ITEM_COUNT_QUERY } from './cartTrigger.gql';
import { Portal } from '../Portal';
var MiniCart = React.lazy(() => import('../MiniCart'));
var CartTrigger = props => {
  var {
    setSchedule,
    schedule
  } = props;
  var {
    handleTriggerClick,
    itemCount,
    miniCartRef,
    miniCartIsOpen,
    hideCartTrigger,
    setMiniCartIsOpen,
    miniCartTriggerRef
  } = useCartTrigger({
    setSchedule,
    schedule,
    queries: {
      getItemCountQuery: GET_ITEM_COUNT_QUERY
    }
  });
  var classes = mergeClasses(defaultClasses, props.classes);
  var {
    formatMessage
  } = useIntl();
  var buttonAriaLabel = formatMessage({
    id: 'cartTrigger.ariaLabel',
    defaultMessage: 'Toggle mini cart. You have {count} items in your cart.'
  }, {
    count: itemCount
  });
  var itemCountDisplay = itemCount > 99 ? '99+' : itemCount;
  var triggerClassName = miniCartIsOpen ? classes.triggerContainer_open : classes.triggerContainer;
  var maybeItemCounter = itemCount ? /*#__PURE__*/React.createElement("span", {
    className: classes.counter
  }, itemCountDisplay) : null;
  return hideCartTrigger ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: triggerClassName,
    ref: miniCartTriggerRef
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": buttonAriaLabel,
    className: classes.trigger,
    onClick: handleTriggerClick
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.imageCounterContainer
  }, maybeItemCounter, /*#__PURE__*/React.createElement("img", {
    src: Cart,
    alt: 'cart'
  })))), /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, miniCartIsOpen && /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement("div", {
    className: classes.modalOverlay
  }, /*#__PURE__*/React.createElement(MiniCart, {
    isOpen: miniCartIsOpen,
    setIsOpen: setMiniCartIsOpen,
    ref: miniCartRef
  })))));
};
export default CartTrigger;
CartTrigger.propTypes = {
  classes: shape({
    counter: string,
    link: string,
    openIndicator: string,
    root: string,
    trigger: string,
    triggerContainer: string
  })
};